import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { apiErrorMessage } from '@/lib/api';
import { useLogin, useMe } from '@/hooks/useAuth';

export function LoginPage() {
  const { data: user } = useMe();
  const login = useLogin();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if (user) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-dvh items-center justify-center bg-muted/30 p-4">
      <form
        className="card w-full max-w-sm space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await login.mutateAsync({ email, password });
            navigate('/');
          } catch (err) {
            toast.error(apiErrorMessage(err, 'Correo o contraseña incorrectos'));
          }
        }}
      >
        <div>
          <h1 className="text-lg font-semibold">EMC</h1>
          <p className="text-sm text-muted-foreground">Control de deudas y gastos personales</p>
        </div>
        <div className="space-y-1">
          <label className="text-xs font-medium text-muted-foreground">Correo</label>
          <Input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            autoComplete="email"
          />
        </div>
        <div className="space-y-1">
          <label className="text-xs font-medium text-muted-foreground">Contraseña</label>
          <Input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        <Button type="submit" className="w-full" disabled={login.isPending}>
          {login.isPending ? 'Entrando…' : 'Entrar'}
        </Button>
      </form>
    </div>
  );
}
